import React, { useMemo, useState } from "react";
import {
  BookOpen, Search, LayoutDashboard, Users2, Trophy, Zap, FileSignature,
  PhoneCall, Flame, GitCompare, ChevronDown, Lightbulb, ListChecks,
} from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { COLORS } from "@/lib/constants";

const NAVY = COLORS.navy;

const SECTIONS = [
  {
    id: "genel-panel",
    icon: LayoutDashboard,
    title: "Genel Panel",
    desc: "Komitenizin genel durumunu tek ekranda görürsünüz: toplam firma, FAAL üye sayısı, tahmin dağılımı ve hedefe ne kadar kaldığı.",
    keywords: "dashboard özet tahmin dağılımı hedef ilerleme geri sayım kesin karşı belki",
    steps: [
      "Sol menüden \"Genel Panel\"e girin. En üstte seçime kalan süre (geri sayım) görünür.",
      "Kartlarda komitenizdeki toplam firma, FAAL üye ve mevcut tahmin dağılımını (Kesin / Belki / Karşı / Ulaşılamadı) inceleyin.",
      "\"Hedef İlerlemesi\" bölümünde, hedeflenen oya göre kaç KESİN oyunuz olduğunu ve yüzdeyi takip edin.",
      "Grafiklerin üstüne gelerek (hover) her dilimin tam sayısını görebilirsiniz.",
    ],
    tips: [
      "Panel her giriş yaptığınızda güncel veriyi gösterir; ayrıca gün boyunca yaptığınız değişiklikler anında yansır.",
    ],
  },
  {
    id: "secmen-listesi",
    icon: Users2,
    title: "Seçmen Listesi (Firma Yönetimi)",
    desc: "Komitenizdeki tüm firmaları görür, arar, filtreler ve her firmanın tahmin/durum/not bilgilerini güncellersiniz. Günlük çalışmanızın merkezidir.",
    keywords: "firma seçmen listesi düzenle tahmin durum faal aski arama notu yetki belgesi filtre ara kopyala excel pdf export",
    steps: [
      "Sol menüden \"Seçmen Listesi\"ne girin. Üstteki arama kutusuna firma ünvanının bir kısmını yazarak hızlıca bulun.",
      "Filtreleri kullanın: Durum (FAAL/ASKI), Tahmin (Kesin/Belki/Karşı…), Sorumlu ve Yetki Belgesi gibi ölçütlerle listeyi daraltın.",
      "Bir firmaya tıklayın; açılan firma kartında bilgileri düzenleyin.",
      "TAHMİN: Firmanın 2026 oy eğilimini (Kesin / Belki / Karşı / Gelmeyecek / Ulaşılamadı) seçin.",
      "DURUM: Firmanın FAAL veya ASKI olduğunu işaretleyin.",
      "ARAMA NOTU: \"Arama Kayıtları\" alanına görüşme notunu yazıp ekleyin; her not tarih ve kullanıcı adıyla saklanır.",
      "YETKİ BELGESİ: Firmadan yetki belgesi alındıysa ilgili kutuyu işaretleyin.",
      "Firma ünvanını kopyalamak için başlığın yanındaki kopyala simgesine tıklayın.",
      "Kaydet'e bastığınızda değişiklik anında panolara ve karneye yansır.",
      "Gerektiğinde sağ üstteki Excel / PDF butonlarıyla listenizi dışa aktarın.",
    ],
    tips: [
      "Sorumlu ataması yaparak firmaları saha ekibi arasında paylaştırabilirsiniz.",
      "Zaman Tüneli sekmesinden bir firmanın geçmiş tüm değişiklik ve notlarını görebilirsiniz.",
    ],
  },
  {
    id: "komite-karnesi",
    icon: Trophy,
    title: "Komite Karnesi",
    desc: "Komitenizin performansını hedefe göre ölçen özet karne. Kaç KESİN oyunuz var, hedefin neresindesiniz ve durum ne kadar sağlıklı görürsünüz.",
    keywords: "karne performans hedef kesin oy sağlık skor komite",
    steps: [
      "Sol menüden \"Komite Karnesi\"ne girin.",
      "Hedef oy, mevcut KESİN oy ve tamamlanma yüzdesini inceleyin.",
      "Sağlık göstergesi (renk/rozet) ile komitenin hedefe göre durumunu bir bakışta değerlendirin.",
    ],
    tips: [
      "Karnedeki sayılar Seçmen Listesi'ndeki tahmin/durum güncellemelerinizle otomatik hesaplanır.",
    ],
  },
  {
    id: "verimlilik",
    icon: Zap,
    title: "Meclis Üyesi Verimliliği (Verimlilik)",
    desc: "Hangi meclis üyesinin / komitenin kaç oy getirdiğini ve en verimli firmaları görerek çabanızı en çok kazandıran yerlere yönlendirirsiniz.",
    keywords: "verimlilik meclis üyesi getiri en verimli komite firma öncelik",
    steps: [
      "Sol menüden \"Meclis Üyesi Verimliliği\"ne girin.",
      "Sıralamada en çok oy getiren komite/üyeleri ve firmaları görün.",
      "Bu bilgiye göre saha çalışmanızı en yüksek getirili firmalara odaklayın.",
    ],
    tips: [
      "En verimli firmalar, sınırlı zamanda en fazla oyu kazandıracak önceliklerinizdir.",
    ],
  },
  {
    id: "yetki-takip",
    icon: FileSignature,
    title: "Yetki Belgesi Takip",
    desc: "Hangi firmalardan yetki belgesi alındığını, hangilerinin beklediğini takip eder ve belge hazırlığınızı yönetirsiniz.",
    keywords: "yetki belgesi takip vekalet müşterek münferit hazırlık randevu",
    steps: [
      "Sol menüden \"Yetki Belgesi Takip\"e girin.",
      "Belgesi alınan ve bekleyen firmaları listeden ayırt edin.",
      "Eksik belgeler için ilgili firmaları önceliklendirip saha planınıza ekleyin.",
    ],
    tips: [
      "Bir firmanın yetki belgesi durumunu Seçmen Listesi'ndeki firma kartından da işaretleyebilirsiniz.",
    ],
  },
  {
    id: "arama-asistani",
    icon: PhoneCall,
    title: "Arama Asistanı",
    desc: "Aranacak firmaları sıraya dizerek telefon görüşmelerinizi hızlandırır; her görüşme sonrası tahmin ve notu tek ekranda kaydedersiniz.",
    keywords: "arama asistanı telefon görüşme sıralı ara not tahmin ulaşılamadı",
    steps: [
      "Sol menüden \"Arama Asistanı\"na girin.",
      "Önerilen/sıradaki firmayı arayın; görüşme sonucunu (tahmin) seçin.",
      "Görüşme notunu yazıp kaydedin ve bir sonraki firmaya geçin.",
    ],
    tips: [
      "Ulaşamadığınız firmaları \"Ulaşılamadı\" olarak işaretleyip daha sonra tekrar deneyebilirsiniz.",
    ],
  },
  {
    id: "akilli-oncelik",
    icon: Flame,
    title: "Akıllı Öncelik",
    desc: "Sistemin, en çok fark yaratacak firmaları öne çıkardığı akıllı liste. Zamanınızı en kritik firmalara ayırmanızı sağlar.",
    keywords: "akıllı öncelik kritik firma sıralama etki öneri",
    steps: [
      "Sol menüden \"Akıllı Öncelik\"e girin.",
      "Öne çıkarılan öncelikli firmaları inceleyin.",
      "Listedeki firmalara odaklanarak en yüksek etkili aramaları/ziyaretleri planlayın.",
    ],
    tips: [
      "Öncelik listesi, tahminleri güncelledikçe kendini yeniler.",
    ],
  },
  {
    id: "zaman-tuneli",
    icon: GitCompare,
    title: "Zaman Tüneli Karşılaştır",
    desc: "Komitenizin durumunu farklı tarihler arasında karşılaştırır; ilerlemenizi (KESİN oy artışı vb.) zaman içinde görürsünüz.",
    keywords: "zaman tüneli karşılaştır tarih ilerleme değişim trend snapshot",
    steps: [
      "Sol menüden \"Zaman Tüneli Karşılaştır\"a girin.",
      "Karşılaştırmak istediğiniz iki tarihi/dönemi seçin.",
      "Aradaki farkı (artan/azalan tahminler) inceleyerek ilerlemenizi değerlendirin.",
    ],
    tips: [
      "Anlamlı bir karşılaştırma için sistemin birkaç günlük veri biriktirmiş olması gerekir.",
    ],
  },
];

const norm = (s) => (s || "").toLocaleLowerCase("tr");

export default function UserGuide() {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(() => new Set([SECTIONS[0].id]));

  const filtered = useMemo(() => {
    const q = norm(query).trim();
    if (!q) return SECTIONS;
    return SECTIONS.filter((s) => {
      const hay = norm(`${s.title} ${s.desc} ${s.keywords} ${s.steps.join(" ")} ${(s.tips || []).join(" ")}`);
      return hay.includes(q);
    });
  }, [query]);

  const searching = query.trim().length > 0;

  const toggle = (id) => {
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  return (
    <div className="space-y-6" data-testid="user-guide-page">
      <div className="flex items-start gap-3">
        <div className="h-11 w-11 rounded-xl grid place-items-center shrink-0" style={{ background: `${NAVY}14`, color: NAVY }}>
          <BookOpen className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold" style={{ color: NAVY }}>Kullanım Kılavuzu</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Komite yöneticileri için temel özelliklerin adım adım anlatımı. Aramak istediğiniz konuyu yazın.</p>
        </div>
      </div>

      <div className="relative max-w-xl">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          data-testid="guide-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Örn: arama notu, yetki belgesi, tahmin, hedef…"
          className="pl-9"
        />
      </div>

      {filtered.length === 0 ? (
        <Card className="p-8 text-center text-muted-foreground" data-testid="guide-empty">
          "{query}" için sonuç bulunamadı. Farklı bir kelime deneyin.
        </Card>
      ) : (
        <div className="space-y-3">
          {filtered.map((s, idx) => {
            const Icon = s.icon;
            const isOpen = searching || open.has(s.id);
            return (
              <Card key={s.id} className="overflow-hidden" data-testid={`guide-section-${s.id}`}>
                <button
                  type="button"
                  onClick={() => toggle(s.id)}
                  data-testid={`guide-section-toggle-${s.id}`}
                  className="w-full flex items-center gap-3 px-5 py-4 text-left hover:bg-muted/40 transition-colors"
                >
                  <div className="h-9 w-9 rounded-lg grid place-items-center shrink-0" style={{ background: `${NAVY}12`, color: NAVY }}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold text-foreground flex items-center gap-2">
                      <span className="text-xs font-bold px-1.5 py-0.5 rounded" style={{ background: `${NAVY}12`, color: NAVY }}>{idx + 1}</span>
                      {s.title}
                    </p>
                    {!isOpen && <p className="text-xs text-muted-foreground truncate mt-0.5">{s.desc}</p>}
                  </div>
                  <ChevronDown className={`h-5 w-5 text-muted-foreground shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>

                {isOpen && (
                  <div className="px-5 pb-5 pt-1 space-y-4 border-t border-border">
                    <p className="text-sm text-muted-foreground">{s.desc}</p>

                    <div className="space-y-2">
                      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide" style={{ color: NAVY }}>
                        <ListChecks className="h-4 w-4" /> Adımlar
                      </p>
                      <ol className="space-y-2">
                        {s.steps.map((st, i) => (
                          <li key={i} className="flex gap-3 text-sm">
                            <span className="shrink-0 h-5 w-5 rounded-full grid place-items-center text-[11px] font-bold text-white" style={{ background: NAVY }}>{i + 1}</span>
                            <span className="text-foreground">{st}</span>
                          </li>
                        ))}
                      </ol>
                    </div>

                    {(s.tips || []).length > 0 && (
                      <div className="rounded-lg p-3 space-y-1.5" style={{ background: "#F59E0B14", border: "1px solid #F59E0B33" }}>
                        {s.tips.map((t, i) => (
                          <p key={i} className="flex items-start gap-2 text-sm" style={{ color: "#92600A" }}>
                            <Lightbulb className="h-4 w-4 shrink-0 mt-0.5" style={{ color: "#D97706" }} />
                            <span>{t}</span>
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
